import { jsx as _jsx } from "react/jsx-runtime";
import useStyles from './FilterChip.styles';
import { Close } from '@mui/icons-material';
import { Chip as ImportedChip } from '@mui/material';
const FilterChip = ({ label, onDelete }) => {
    const { classes } = useStyles();
    return _jsx(ImportedChip, { className: classes.FilterChip, onDelete: onDelete, label: label, deleteIcon: _jsx(Close, {}) });
};
export default FilterChip;
